import { Element } from "../Element.mjs";
import { isBoolean, isEnum, isString, isUuid } from "../validation/index.mjs";
export var ButtonBlockNode;

(function (ButtonBlockNode) {
  ButtonBlockNode.TYPE = 'button-block';
  var Layout;

  (function (Layout) {
    Layout["LEFT"] = "left";
    Layout["CENTER"] = "center";
    Layout["RIGHT"] = "right";
    Layout["WIDE"] = "wide";
  })(Layout = ButtonBlockNode.Layout || (ButtonBlockNode.Layout = {}));

  var Variant;

  (function (Variant) {
    Variant["DEFAULT"] = "default";
    Variant["OUTLINE"] = "outline";
  })(Variant = ButtonBlockNode.Variant || (ButtonBlockNode.Variant = {}));

  function isButtonBlockNode(value) {
    return Element.isElement(value, ButtonBlockNode.TYPE);
  }

  ButtonBlockNode.isButtonBlockNode = isButtonBlockNode;

  function validateButtonBlockNode(value) {
    var isValid = isButtonBlockNode(value) && isString(value.href) && isString(value.label) && isUuid(value.uuid) && isEnum(value.layout, Layout) && isEnum(value.variant, Variant) && isBoolean(value.new_tab);
    return isValid ? value : null;
  }

  ButtonBlockNode.validateButtonBlockNode = validateButtonBlockNode;
})(ButtonBlockNode || (ButtonBlockNode = {}));